import {Box, Grid} from '@primer/react-brand/esm'

import type {FlexSuiteDefaultHeroProps} from './types'
import {HeroContent} from './HeroContent'
import baseStyles from '../../styles/base.module.css'

/**
 * Default hero (no variant specified): text-only gridline
 */
export function FlexSuiteHeroDefault({fields}: {fields: FlexSuiteDefaultHeroProps}) {
  return (
    <Box className={baseStyles.gridFrameBottom} data-testid="hero-default">
      <Grid>
        <Grid.Column>
          <HeroContent {...fields} />
        </Grid.Column>
      </Grid>
    </Box>
  )
}
